<template>
  <StructuredData id="schema-webpage" :schema="webPageSchema" />
  <div v-if="!initializing" class="container superior">
    <div class="row">
      <div class="col">
        <h2 class="text-primary display-5 bold text-start">{{ $t('general.politicaPrivacidad') }}</h2>
      </div>
    </div>
    <div class="row mt-4">
      <div class="card card-body translate">
        <p v-sanitize-html="politicaPrivacidad" class="text-primary translate"></p>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { ref, onBeforeMount } from 'vue';
  import HomeApiService from '@/services/api/HomeApiService';
  import StructuredData from '@/components/utils/StructuredData.vue';
  import { useLoadingStore } from '@/store_pinia/loadingStore';
  import { usePageMeta } from '@/composables/usePageMeta';

  const loadingStore = useLoadingStore();
  const { webPageSchema } = usePageMeta();
  const initializing = ref(true);
  const politicaPrivacidad = ref('');

  async function fetchPoliticaPrivacidad() {
    try {
      loadingStore.show();
      const response = await HomeApiService.getPrivacyPolicy();
      politicaPrivacidad.value = response.texto;
    } catch (error) {
      console.error('Error al obtener la política de privacidad:', error);
      politicaPrivacidad.value = '';
    } finally {
      initializing.value = false;
      loadingStore.hide();
    }
  }

  onBeforeMount(() => {
    fetchPoliticaPrivacidad();
  });
</script>

<style scoped lang="scss">
  .card-body {
    border: none;
    padding: 2rem;

    :deep(h3) {
      color: var(--bs-primary);
      font-size: 1.75rem;
      margin-bottom: 1.5rem;
    }

    :deep(h4) {
      color: var(--bs-primary);
      font-size: 1.25rem;
      margin-top: 2rem;
      margin-bottom: 1rem;
    }

    :deep(p) {
      margin-bottom: 1rem;
    }

    :deep(ul) {
      list-style-type: disc;
      margin-left: 1.5rem;
      margin-bottom: 1rem;
    }

    :deep(li) {
      margin-bottom: 0.5rem;
    }

    :deep(a) {
      color: var(--bs-primary);
      text-decoration: underline;

      &:hover {
        color: var(--bs-secondary);
      }
    }
  }

  .superior {
    max-width: 1200px;
    margin: 0 auto;
    padding: 25px 0;
    padding-top: 11rem;
  }

  @media only screen and (max-width: 768px) {
    .superior {
      padding: 7rem 15px;
    }

    .card-body {
      padding: 1rem;

      :deep(h3) {
        font-size: 1.5rem;
      }

      :deep(h4) {
        font-size: 1.1rem;
      }
    }
  }
</style>
